import { useCallback, useEffect } from "react";
import { useLocalStorage } from "@/modern/hooks/useLocalStorage";

const STORAGE_KEY = "entity-manager-enhanced-borders";

const changeListeners = new Set<(value: boolean) => void>();

export function useEntityManagerEnhancedBorders(): [boolean, (value: boolean) => void] {
  const [enabled, setStored] = useLocalStorage<boolean>(STORAGE_KEY, false);

  useEffect(() => {
    changeListeners.add(setStored);
    return () => {
      changeListeners.delete(setStored);
    };
  }, [setStored]);

  const setEnabled = useCallback(
    (value: boolean) => {
      setStored(value);
      changeListeners.forEach((listener) => {
        if (listener !== setStored) {
          listener(value);
        }
      });
    },
    [setStored]
  );

  return [enabled, setEnabled];
}
